/* ==========================================================================
   STARKFELD — Newsletter Popup (Liquid Glass) — behaviour + Klaviyo tracking
   Option A (Voll-Custom): eigenes Design + volle Klaviyo-Nachvollziehbarkeit.

   Tracking-Architektur (verifiziert):
   - Submit -> POST /client/subscriptions/ in eine DEDIZIERTE Liste (DOI),
     mit custom_source + dauerhaften Profil-Properties (signup_source/form/placement).
     Die HTTP-Antwort ist die Wahrheit ("Signup passiert"), nicht das Event.
   - Events via klaviyo.js (guarded): "Viewed Newsletter Popup" beim Oeffnen,
     "Submitted Newsletter Popup" nach erfolgreichem Subscribe (identify-first).
   - revision-Header aktuell (2026-04-15). DSGVO: Ziel-Liste MUSS Double-Opt-In sein.
   ========================================================================== */
(function () {
  if (window.customElements && customElements.get('sf-newsletter-glass')) return;

  var STORAGE_KEY = 'sf:newsletter-glass';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var BOTTOM_BARS = '.product-sticky-form, .mobile-dock, [data-sticky-cart], [class*="sticky-atc"]';
  var WEBMAIL = {
    'gmail.com':'https://mail.google.com/mail/u/0/','googlemail.com':'https://mail.google.com/mail/u/0/',
    'outlook.com':'https://outlook.live.com/mail/','hotmail.com':'https://outlook.live.com/mail/','hotmail.de':'https://outlook.live.com/mail/','live.com':'https://outlook.live.com/mail/','live.de':'https://outlook.live.com/mail/','msn.com':'https://outlook.live.com/mail/',
    'yahoo.com':'https://mail.yahoo.com/','yahoo.de':'https://mail.yahoo.com/',
    'gmx.de':'https://www.gmx.net/','gmx.net':'https://www.gmx.net/','gmx.com':'https://www.gmx.com/',
    'web.de':'https://web.de/','t-online.de':'https://email.t-online.de/',
    'icloud.com':'https://www.icloud.com/mail/','me.com':'https://www.icloud.com/mail/','mac.com':'https://www.icloud.com/mail/'
  };

  function readState(){ try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch (e) { return {}; } }
  function writeState(patch){ try { var s = readState(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch (e) {} }

  /* Klaviyo onsite helpers — guarded (klaviyo.js kann durch Adblock/Consent fehlen) */

  /* C1 (2026-08-27): the popup must never fire in the buying path. The
     section is already not rendered on /cart and checkout paths (Liquid
     guard in sf-newsletter-glass.liquid); this is the second, JS-side
     guard in case the section ever gets included there again. Matches
     /cart, /checkout and /checkouts as full path segments, including
     locale prefixes like /en/cart. */
  function isBuyingPath() {
    try {
      var path = (window.location.pathname || '').toLowerCase();
      return /(^|\/)(cart|checkout|checkouts)(\/|$)/.test(path);
    } catch (e) { return false; }
  }

  class SfNewsletterGlass extends HTMLElement {
    connectedCallback() {
      if (isBuyingPath()) return;
      if (this._init) return; this._init = true;
      this.overlay = this.querySelector('.sfng-overlay');
      this.card = this.querySelector('.sfng-card');
      this.teaser = this.querySelector('.sfng-teaser');
      this.form = this.querySelector('.sfng-form');
      this.input = this.querySelector('.sfng-input');
      this.button = this.querySelector('.sfng-btn');
      this.errorEl = this.querySelector('.sfng-error');
      if (!this.overlay || !this.card) return;

      var d = this.dataset;
      this.cfg = {
        delay: parseInt(d.delay || '0', 10),
        scroll: parseInt(d.scroll || '0', 10),
        exit: d.exit === 'true',
        frequency: parseInt(d.frequency || '7', 10),
        company: (d.company || '').trim(),
        list: (d.list || '').trim(),
        revision: (d.revision || '2026-04-15').trim(),
        source: (d.source || 'custom_newsletter_popup').trim(),
        popupId: (d.popupId || 'newsletter_v1').trim(),
        variant: (d.variant || 'glass_v1').trim(),
        placement: (d.placement || 'homepage-modal').trim(),
        test: d.test === 'true'
      };
      this.eventProps = { popup_id: this.cfg.popupId, variant: this.cfg.variant, placement: this.cfg.placement };

      this._bind();
      this._bindReposition();
      this._decide();
    }

    _bind() {
      var self = this;
      this.querySelectorAll('[data-sfng-close]').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); self.close(); }); });
      this.overlay.addEventListener('click', function (e) { if (e.target === self.overlay) self.close(); });
      this._onKey = function (event) {
        if (!self.isConnected || !self.overlay.classList.contains('is-open')) return;
        if (event.key === 'Escape') { event.preventDefault(); self.close(); return; }
        if (event.key !== 'Tab') return;
        var focusable = self._focusableElements();
        var index = focusable.indexOf(document.activeElement);
        if (!focusable.length || index < 0 || (event.shiftKey && index === 0) || (!event.shiftKey && index === focusable.length - 1)) {
          event.preventDefault();
          self._focusElement(focusable.length ? focusable[event.shiftKey ? focusable.length - 1 : 0] : self.overlay);
        }
      };
      document.addEventListener('keydown', this._onKey);
      this._onFocus = function (event) {
        if (self.isConnected && self.overlay.classList.contains('is-open') && !self.overlay.contains(event.target)) self._focusInside(false);
      };
      document.addEventListener('focusin', this._onFocus);

      if (this.teaser) {
        this.teaser.addEventListener('keydown', function (event) {
          if (event.target === self.teaser && self.teaser.getAttribute('role') === 'button' && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault(); self.open(false);
          }
        });
        this.teaser.addEventListener('click', function (e) { if (e.target.closest('[data-sfng-teaser-close]')) return; self.open(); });
        var tx = this.teaser.querySelector('[data-sfng-teaser-close]');
        if (tx) tx.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self._hideTeaser(); if (!self.cfg.test) writeState({ dismissedAt: Date.now() }); });
      }
      this._mountHub();
      var inbox = this.querySelector('[data-sfng-inbox]');
      if (inbox) inbox.addEventListener('click', function () { self._openInbox(); });
    }

    _canFocus(element) {
      if (!element || !element.isConnected || element.disabled || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
      var style = window.getComputedStyle(element);
      return element.getClientRects().length > 0 && style.visibility !== 'hidden' && style.visibility !== 'collapse' && style.display !== 'none';
    }

    _focusableElements() {
      var self = this;
      return Array.prototype.slice.call(this.card.querySelectorAll('button, input, select, textarea, a[href], [tabindex]')).filter(function (element) {
        return element.tabIndex >= 0 && !element.matches(':disabled') && self._canFocus(element);
      });
    }

    _focusElement(element) {
      if (!element) return;
      if (element === this.overlay) element.setAttribute('tabindex', '-1');
      try { element.focus({ preventScroll: true }); } catch (e) { element.focus(); }
    }

    _focusInside(preferEmail) {
      var focusable = this._focusableElements();
      this._focusElement(preferEmail && focusable.indexOf(this.input) >= 0 ? this.input : (focusable[0] || this.overlay));
    }

    _restoreFocus() {
      var target = this._returnFocus;
      this._returnFocus = null;
      if (!this._canFocus(target) || target === document.body || this.overlay.contains(target)) {
        target = this.teaser && (this.teaser.querySelector('[data-sfng-teaser-open]') || this.teaser);
      }
      if (this._canFocus(target)) this._focusElement(target);
      else {
        var main = document.querySelector('main');
        if (main && this._canFocus(main)) {
          var tabindex = main.getAttribute('tabindex');
          main.setAttribute('tabindex', '-1');
          this._focusElement(main);
          if (tabindex === null) main.removeAttribute('tabindex');
          else main.setAttribute('tabindex', tabindex);
        }
      }
    }

    _bindReposition() {
      var self = this, raf = 0;
      this._reposition = function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; self._positionTeaser(); }); };
      window.addEventListener('resize', this._reposition, { passive: true });
      window.addEventListener('scroll', this._reposition, { passive: true });
    }

    _decide() {
      var s = readState(), self = this;
      if (this.cfg.test) { setTimeout(function () { self.open(); }, 400); return; }
      if (s.subscribed) return;
      var windowMs = this.cfg.frequency * 86400000;
      if (s.dismissedAt && (Date.now() - s.dismissedAt) < windowMs) { this._showTeaser(); return; }
      this._armTriggers();
    }

    _armTriggers() {
      var self = this, fired = false, cleanup = [];
      function trigger() { if (fired) return; fired = true; cleanup.forEach(function (fn) { fn(); }); self.open(); }
      if (this.cfg.delay > 0) { var t = setTimeout(trigger, this.cfg.delay * 1000); cleanup.push(function () { clearTimeout(t); }); }
      if (this.cfg.scroll > 0) {
        var onScroll = function () { var h = document.documentElement; var max = h.scrollHeight - h.clientHeight; var pct = max > 0 ? (h.scrollTop / max) * 100 : 0; if (pct >= self.cfg.scroll) trigger(); };
        window.addEventListener('scroll', onScroll, { passive: true }); cleanup.push(function () { window.removeEventListener('scroll', onScroll); });
      }
      if (this.cfg.exit && !('ontouchstart' in window)) {
        var onLeave = function (e) { if (e.clientY <= 0) trigger(); };
        document.addEventListener('mouseout', onLeave); cleanup.push(function () { document.removeEventListener('mouseout', onLeave); });
      }
      if (this.cfg.delay <= 0 && this.cfg.scroll <= 0 && !this.cfg.exit) { var dd = setTimeout(trigger, 6000); cleanup.push(function () { clearTimeout(dd); }); }
    }

    open() {
      if (this.overlay.classList.contains('is-open')) return;
      this._returnFocus = document.activeElement;
      if (!this._opened) this._opened = true;
      this._hideTeaser();
      this.overlay.classList.add('is-open');
      this.overlay.setAttribute('aria-hidden', 'false');
      this._lock(true);
      this._focusInside(true);
      // Visibility can still be transitioning on the opening frame.
      var self = this;
      this._focusTimer = setTimeout(function () {
        self._focusTimer = null;
        if (self.isConnected && self.overlay.classList.contains('is-open') && !self.overlay.contains(document.activeElement)) self._focusInside(true);
      }, 80);
    }

    close() {
      if (!this.overlay.classList.contains('is-open')) return;
      clearTimeout(this._focusTimer);
      this._focusTimer = null;
      this.overlay.classList.remove('is-open');
      this._lock(false);
      if (!this.card.classList.contains('is-success')) { this._showTeaser(); this._positionTeaser(); }
      if (!this.cfg.test) writeState({ dismissedAt: Date.now() });
      this._restoreFocus();
      this.overlay.setAttribute('aria-hidden', 'true');
    }

    _showTeaser() { if (this.teaser) this.teaser.classList.add('is-visible'); }
    _hideTeaser() { if (this.teaser) this.teaser.classList.remove('is-visible'); }

    _positionTeaser() {
      if (!this.teaser || !this.teaser.classList.contains('is-visible')) return;
      var vpH = document.documentElement.clientHeight, lift = 0;
      document.querySelectorAll(BOTTOM_BARS).forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) return;
        var r = el.getBoundingClientRect();
        if (r.height < 8) return;
        if (r.top < vpH && r.bottom > vpH * 0.55) lift = Math.max(lift, vpH - r.top + 20);
      });
      this.teaser.style.setProperty('--sfng-teaser-bottom', (lift > 0 ? lift : 22) + 'px');
    }

    _lock(on) {
      if (on) { this._prevOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
      else { document.body.style.overflow = this._prevOverflow || ''; }
    }

    _mountHub() {
      var self = this;
      if (!this.form) return;
      this.form.dataset.sfHubPreview = this.cfg.test ? 'true' : 'false';
      if (!window.SfNewsletterHub) {
        this.input.disabled = true; this.button.disabled = true;
        if (!this._hubListener) {
          this._hubListener = function () { document.removeEventListener('sf:newsletter-hub-ready', self._hubListener); self._hubListener = null; self._mountHub(); };
          document.addEventListener('sf:newsletter-hub-ready', this._hubListener);
        }
        return;
      }
      window.SfNewsletterHub.mount(this.form, {
        errorElement: this.errorEl,
        onBusy: function (busy) { self.button.classList.toggle('is-loading', busy); },
        onAccepted: function (email) {
          // This suppresses the popup only; it does not assert backend consent.
          if (!self.cfg.test) writeState({ subscribed: true, dismissedAt: Date.now() });
          self._hideTeaser(); self._showInboxButton(email); self.card.classList.add('is-success');
          if (self.overlay.classList.contains('is-open') && (!self.overlay.contains(document.activeElement) || !self._canFocus(document.activeElement))) self._focusInside(false);
        }
      });
    }

    _openInbox() {
      var v = (this.input.value || '').trim().toLowerCase(), dom = v.split('@')[1] || '';
      var url = WEBMAIL[dom];           // NUR bekannte Webmail-Anbieter — niemals https://<firmendomain>
      if (url) window.open(url, '_blank', 'noopener');
    }
    _showInboxButton(email) {
      var btn = this.querySelector('[data-sfng-inbox]');
      if (!btn) return;
      var dom = ((email || '').split('@')[1] || '').toLowerCase();
      btn.style.display = WEBMAIL[dom] ? '' : 'none';  // unbekannte/Firmen-Domain -> Button ausblenden
    }

    _showError(msg) { if (this.errorEl) { this.errorEl.textContent = msg; this.errorEl.classList.add('is-visible'); } }
    _clearError() { if (this.input) this.input.classList.remove('is-invalid'); if (this.errorEl) { this.errorEl.textContent = ''; this.errorEl.classList.remove('is-visible'); } }
  }

  customElements.define('sf-newsletter-glass', SfNewsletterGlass);
})();
